import { useAuthContext } from 'contexts/AuthContext';
import { Navigate } from 'react-router-dom';

function AuthGuard(props: any) {
  const { children } = props;

  const { auth } = useAuthContext();
  if (auth?.token) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default AuthGuard;
